export default __webpack_public_path__ + "static/media/make-move.a34ee420.mp3";